import { render, staticRenderFns } from "./question-multi-choice.vue?vue&type=template&id=58588263"
import script from "./question-multi-choice.vue?vue&type=script&lang=js"
export * from "./question-multi-choice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports